module.exports = __webpack_public_path__ + "media/images/products/intro/1-f0c86df4bac0eb2bf5ea2e404b5bb21b.svg";